<template>
  <aside v-if="items.length" class="ad-rail" :class="side">
    <div class="rail-head">
      <p class="rail-label">赞助内容 · 非百科结果</p>
      <button type="button" class="close" title="关闭广告，24 小时内不再展示" @click="$emit('close')">关闭</button>
    </div>
    <a
      v-for="item in items"
      :key="item.id"
      class="ad-card"
      :href="hrefOf(item)"
      :target="isExternal(item) ? '_blank' : undefined"
      :rel="isExternal(item) ? 'noopener sponsored' : undefined"
      @click.prevent="go(item)"
    >
      <span class="ad-badge">广告</span>
      <strong class="ad-title">{{ item.title }}</strong>
      <span v-if="item.subtitle" class="ad-sub">{{ item.subtitle }}</span>
      <span v-if="item.price_label" class="ad-price">{{ item.price_label }}</span>
      <span class="ad-cta">{{ item.cta || '了解详情' }}</span>
    </a>
  </aside>
</template>

<script>
export default {
  name: 'SearchAdRail',
  props: {
    side: { type: String, default: 'right' },
    items: { type: Array, default: () => [] }
  },
  emits: ['close'],
  methods: {
    hrefOf(item) {
      return item.url || '#'
    },
    isExternal(item) {
      const url = item.url || ''
      return /^https?:\/\//i.test(url)
    },
    go(item) {
      const url = item.url || ''
      if (!url) return
      if (this.isExternal(item)) {
        window.open(url, '_blank', 'noopener')
        return
      }
      this.$router.push(url)
    }
  }
}
</script>

<style scoped>
.ad-rail {
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: sticky;
  top: 72px;
  align-self: start;
  opacity: 0.72;
}
.ad-rail:hover { opacity: 0.92; }
.rail-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}
.rail-label {
  margin: 0;
  font-size: 11px;
  color: #a9aeb8;
  letter-spacing: 0.02em;
}
.close {
  border: 0;
  background: transparent;
  color: #a9aeb8;
  font-size: 11px;
  padding: 0;
  cursor: pointer;
}
.close:hover { color: #86909c; }
.ad-card {
  display: grid;
  gap: 6px;
  padding: 12px;
  background: rgba(247, 248, 250, 0.85);
  border: 1px dashed #d0d3d9;
  border-radius: 6px;
  text-decoration: none;
  color: inherit;
  transition: opacity 0.15s, border-color 0.15s, background 0.15s;
}
.ad-card:hover {
  border-color: #c9cdd4;
  background: rgba(242, 243, 245, 0.95);
}
.ad-badge {
  justify-self: start;
  font-size: 10px;
  color: #a9aeb8;
  border: 1px solid #d0d3d9;
  border-radius: 2px;
  padding: 0 4px;
  line-height: 16px;
  background: rgba(255, 255, 255, 0.5);
}
.ad-title {
  font-size: 13px;
  font-weight: 500;
  color: #4e5969;
  line-height: 1.35;
}
.ad-sub {
  font-size: 12px;
  color: #86909c;
  line-height: 1.45;
}
.ad-price {
  font-size: 12px;
  color: #86909c;
}
.ad-cta {
  font-size: 12px;
  color: #86909c;
  margin-top: 2px;
}
</style>
